import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 2,
  "data-testid": "detail-top_html",
  class: /*@__PURE__*/_normalizeClass({'monospace': true})
}

import CodeMirror from '@shell/components/CodeMirror.vue';
import { _VIEW } from '@shell/config/query-params';
import { nlToBr } from '@shell/utils/string';
import { computed } from 'vue';

export interface Props {
  value: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Content',
  props: {
    value: {}
  },
  setup(__props: any) {

const props = __props;

const isEmpty = computed(() => props.value.length === 0);
const jsonStr = computed(() => {
  const value = props.value;

  if ( value && ( value.startsWith('{') || value.startsWith('[') ) ) {
    try {
      let parsed = JSON.parse(value);

      parsed = JSON.stringify(parsed, null, 2);

      return parsed;
    } catch {
    }
  }

  return null;
});

const bodyHtml = computed(() => {
  return nlToBr(props.value);
});


return (_ctx: any,_cache: any) => {
  const _directive_t = _resolveDirective("t")!
  const _directive_clean_html = _resolveDirective("clean-html")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isEmpty.value)
      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_2, null, 512)), [
          [_directive_t, 'detailText.empty']
        ])
      : (jsonStr.value)
        ? (_openBlock(), _createBlock(CodeMirror, {
            key: 1,
            mode: _unref(_VIEW),
            options: {mode:{name:'javascript', json:true}, lineNumbers:false, foldGutter:false},
            value: jsonStr.value
          }, null, 8, ["mode", "value"]))
        : _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_3, null, 512)), [
            [_directive_clean_html, bodyHtml.value]
          ])
  ]))
}
}

})